export default "__VITE_ASSET__BTERyaBa__"